import { TFunction } from 'i18next'

import type { WeekScheduleLabels } from '@/components/business/week-schedule'

export const getSlotLengthOptions = (t: TFunction<['packages-settings']>) => [
  { label: t('packages-settings:generalTab.deliverySlotLength.options.oneHour'), value: 1 },
  { label: t('packages-settings:generalTab.deliverySlotLength.options.twoHours'), value: 2 },
  { label: t('packages-settings:generalTab.deliverySlotLength.options.threeHours'), value: 3 },
  { label: t('packages-settings:generalTab.deliverySlotLength.options.fourHours'), value: 4 },
]

export const getWeekScheduleLabels = (t: TFunction<['packages-settings']>): WeekScheduleLabels => ({
  days: t('packages-settings:generalTab.setDeliveryDays'),
  endPlaceholder: t('packages-settings:dayHoursRow.endPlaceholder'),
  hours: t('packages-settings:generalTab.setDeliveryHours'),
  noHours: t('packages-settings:dayHoursRow.noDeliveries'),
  startPlaceholder: t('packages-settings:dayHoursRow.startPlaceholder'),
  to: t('packages-settings:dayHoursRow.to'),
})

export const getD2DTip = (t: TFunction<['packages-settings']>) =>
  t('packages-settings:generalTab.d2dMode.tip')

export const getAsapTip = (t: TFunction<['packages-settings']>) =>
  t('packages-settings:generalTab.allowASAP.tip')

export const getD2DLockedMessage = (t: TFunction<['packages-settings']>) =>
  t('packages-settings:generalTab.d2dMode.lockedMessage')

export const getQuickScanLockedMessage = (t: TFunction<['packages-settings']>) =>
  t('packages-settings:generalTab.allowQuickScan.lockedMessage')
